import {
  Component, OnInit, Input, Output, OnChanges, EventEmitter,
  Directive, ViewContainerRef, ViewChildren, QueryList, ComponentFactoryResolver, AfterContentInit, ComponentRef
} from '@angular/core';
import { QueryComments } from './querycomments';
import { QuerycommentsService } from './querycomments.service';
import { ChildboxComponent } from './childbox/childbox.component';
import { User } from '../../Master/user/user';
import { UserService } from '../../Master/user/user.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { RequestdashboardComponent } from '../../dashboard/requestdashboard/requestdashboard.component';
import { RequestdashboardService } from '../../dashboard/requestdashboard/requestdashboard.service';

import { DomSanitizer } from '@angular/platform-browser';
import { requeststatus } from '../../dashboard/requestdashboard/requeststatus';
import { Subject } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LocalService } from '../../local.service';
import {encryptdecrypt} from '../../encryptdecrypt';
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[datacontainer]',
})
export class DatacontainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}

@Component({
  selector: 'app-querycomments',
  templateUrl: './querycomments.component.html',
  styleUrls: ['./querycomments.component.css']
})
export class QuerycommentsComponent implements OnInit {
  @Input() requestdetailid: number;
  @Input() requesttypeid: number;
  @Input() redirectype: string;


  userid: number;
  querym: QueryComments = new QueryComments();
  Users: User[];
  user: User;
  currentprofileimage: any = '';
  UserList: any = [];
  id: string;
  requeststatus: requeststatus = new requeststatus();
  querycomment: string;
  querycommentempty: boolean=false;
  public comments: any = [];
  commentForm: FormGroup;
  commentInfo: Array<object> = [];
  submitted: Boolean = false;


  public loadComponent = false;
  public commentIndex = 0;
  public reply: Array<object> = [];
  @ViewChildren(DatacontainerDirective) entry: QueryList<DatacontainerDirective>;


  private componentRef: ComponentRef<any>;

  constructor(private requestdashboardservice: RequestdashboardService, private formBuilder: FormBuilder,
    private _sanitizer: DomSanitizer, private querycommentservice: QuerycommentsService,
    private userservice: UserService, private toastr: ToastrService, private route: ActivatedRoute, 
    private resolver: ComponentFactoryResolver, private localService: LocalService) {
    this.getallusers();
  }

  ngOnInit() {
    this.createForm();
    //this.userid = +localStorage.getItem("userid");
     let a= new encryptdecrypt(); 
    this.userid = +this.localService.getJsonValue("userid");
    this.userservice.Get().toPromise().then(res => {
        res.forEach((data: any) => {
        data.firstname = a.decryptUsingAES256(data.firstname);
        data.lastname = a.decryptUsingAES256(data.lastname);
        data.emailid = a.decryptUsingAES256(data.emailid);
      });
      this.Users = res;
      var alldata = res;
      alldata.forEach(data => {
        if (data.userid == this.userid) {
          this.querycommentservice.GetImage(data.profileimagepath).toPromise().then(res => {
            if (res.type != 'text/plain') {
              let objectURL = 'data:image/jpeg;base64,' + res.image;
              this.currentprofileimage = objectURL;
            }
            this.getAll();
          });
        }
      });
    });
  }


  createForm() {
    this.commentForm = this.formBuilder.group({
      comment: ['', [Validators.required]]
    });
  }



  //create query
  savepost() {
    this.submitted = true;

    this.querycomment = this.commentForm.controls['comment'].value;
    if ((this.querycomment.trim() == undefined) || (this.querycomment.trim() == '')) {
      this.querycommentempty = true;
      return false;
    }

    if (this.commentForm.invalid) {
      return false;
    }
    else {
      this.savequery(this.querycomment.trim(), 0);
      this.commentForm.controls['comment'].setValue(' ');
    }
  }


  //remove comment
  removeComment(id) {

    //this.comments.splice(no, 1);
    this.deletequery(id);

  }
  //trackby ID
  trackById(index: number, item: any) {
    return item.queryid;
  }

  //reply comments
  replyComment(id) {
    this.loadComponent = true;
    const myFactory = this.resolver.resolveComponentFactory(ChildboxComponent);
    // if (this.entry.toArray()[index].viewContainerRef.length <= 0) {
    var i = 0
    this.entry.forEach(container => {
      let containerid = container.viewContainerRef.element.nativeElement.id;
      if (containerid == id) {
        const myRef = this.entry.toArray()[i].viewContainerRef.createComponent(myFactory);
        myRef.instance['queryindexno'] = i;
        myRef.instance['queryid'] = id;
        myRef.instance["createdby"] = this.userid;
        myRef.instance["profile_picture_url"] = this.currentprofileimage;
        myRef.changeDetectorRef.detectChanges();
        myRef.instance.userReplycomment.subscribe(
          data => {
            this.receiveReplyComment(data, 'reply');
          }
        );
        myRef.instance.deletNo.subscribe(
          no => {
            myRef.destroy();
          }
        );
      }
      i = i + 1;
    });
    // }

  }

  //receive reply from child component
  receiveReplyComment(replydata, mode) {
    this.reply = replydata;

    this.reply.forEach((replyelement) => {
      if (mode == 'reply') {
        this.savequery(replyelement['query'], replyelement['queryid']);
      }
      if (mode == 'edit') {
        this.editquery(replyelement['query'], replyelement['queryid']);
      }
    });

    this.loadComponent = false;
  }

  //get all users
  getallusers() {
     let a= new encryptdecrypt(); 
    this.userservice.Get().toPromise().then(res => {
       res.forEach((data: any) => {
        data.firstname = a.decryptUsingAES256(data.firstname);
        data.lastname = a.decryptUsingAES256(data.lastname);
        data.emailid = a.decryptUsingAES256(data.emailid);
      });
      this.Users = res;
      var alldata = res;
      alldata.forEach(data => {
        if (data.active != 0) {
          this.UserList.push({ id: data.userid, fullname: data.firstname, lastname: data.lastname, email: data.emailid, team: data.team, active: data.active })
        }
      });
    }, error => { this.toastr.error('') });
  }




  //edit comments
  editComment(id, query) {
    
    this.loadComponent = true;
    const myFactory = this.resolver.resolveComponentFactory(ChildboxComponent);
    //if (this.entry.toArray()[index].viewContainerRef.length <= 0) {
    var i = 0
    this.entry.forEach(container => {
      let containerid = container.viewContainerRef.element.nativeElement.id;
      if (containerid == id) {
        const myRef = this.entry.toArray()[i].viewContainerRef.createComponent(myFactory);
        myRef.instance['queryindexno'] = i;
        myRef.instance['type'] = 'edit';
        myRef.instance['queryid'] = id;
        myRef.instance['query'] = query;
        myRef.instance["createdby"] = this.userid;
        myRef.instance["profile_picture_url"] = this.currentprofileimage;
        myRef.changeDetectorRef.detectChanges();
        myRef.instance.userReplycomment.subscribe(
          data => {
            this.receiveReplyComment(data, 'edit');
          }
        );
        myRef.instance.deletNo.subscribe(
          no => {
            myRef.destroy();
          }
        );
      }
      i = i + 1;
    });
    //}
  }

  //get all query
  getAll() {
    
  //  this.comments = [];
    var profileurl;
    if (this.redirectype == 'Query') {
      this.querycommentservice.Getquerytree(this.requesttypeid.toString(), this.requestdetailid.toString()).toPromise().then(res => {
        if (res != undefined) {

          
          let jsonArrayObject = [];
          res.forEach(item => {
            if (item.requestdetailid == this.requestdetailid && item.requesttypeid == this.requesttypeid && item.active == 1 && item.parent == 0 && item.type == 'query') {
              if (item.replycomment == null)
                this.reply = [];
              else
                this.reply = item.replycomment;
              jsonArrayObject.push({
                "requestdetailid": item.requestdetailid, "requesttypeid": item.requesttypeid, "createdbyname": item.createdbyname, "queryid": item.queryid, "createdon": item.createdon, "query": item.query, "type": item.type, "createdby": item.createdby, "profile_picture_url": '', "replycomment": this.reply
              });
            }
          });
          this.comments = jsonArrayObject;
          if (this.comments.length > 0) {
            this.comments.forEach(item => {
              this.Users.forEach(data => {
                if (data.userid == item.createdby) {
                  this.querycommentservice.GetImage(data.profileimagepath).toPromise().then(resimage => {
                    if (resimage.type != 'text/plain') {
                      let objectURL = 'data:image/jpeg;base64,' + resimage.image;
                      profileurl = objectURL;
                      item["profile_picture_url"] = profileurl;
                    }
                  });
                }
                item = this.getimageRecursive(item, data);

              });
            });
          }
        }


        //sorting databases
        
        this.comments.sort((a, b) => (a.queryid < b.queryid) ? 1 : -1);

      }, error => {
        this.comments = [];
        this.toastr.error('Error while getting query data')
      });
    }
    else {

      this.querycommentservice.Get().toPromise().then(res => {
        if (res != undefined) {

          
          let jsonArrayObject = [];
          res.forEach(item => {
            if (item.requestdetailid == this.requestdetailid && item.requesttypeid == this.requesttypeid && item.active == 1 && item.parent == 0 && item.type=='comment') {             
              jsonArrayObject.push({
                "requestdetailid": item.requestdetailid, "requesttypeid": item.requesttypeid, "createdbyname": item.createdbyname, "queryid": item.queryid, "createdon": item.createdon, "query": item.query,"type":item.type, "createdby": item.createdby, "profile_picture_url": '', "replycomment": []
              });
            }
          });
          this.comments = jsonArrayObject;
          if (this.comments.length > 0) {
            this.comments.forEach(item => {
              this.Users.forEach(data => {
                if (data.userid == item.createdby) {
                  this.querycommentservice.GetImage(data.profileimagepath).toPromise().then(resimage => {
                    if (resimage.type != 'text/plain') {
                      let objectURL = 'data:image/jpeg;base64,' + resimage.image;
                      profileurl = objectURL;
                      item["profile_picture_url"] = profileurl;
                    }
                  });
                }              
              });
            });
          }
        }
        //sorting databases    
        this.comments.sort((a, b) => (a.queryid < b.queryid) ? 1 : -1);

      }, error => {
        this.comments = [];
        this.toastr.error('Error while getting Comments data')
      });


    }
  }

  //get user image
  getimageRecursive(item, data) {
    if (item.replycomment.length > 0) {
      item["replycomment"].forEach(replydata => {
        if (data.userid == replydata["createdby"]) {
          this.querycommentservice.GetImage(data.profileimagepath).toPromise().then(resimage => {
            if (resimage.type != 'text/plain') {
              let objectURL = 'data:image/jpeg;base64,' + resimage.image;
              replydata["profile_picture_url"] = objectURL;
            }
          });
        }
        if (replydata.replycomment.length > 0)
          replydata = this.getimageRecursive(replydata, data);
      });
    }
    return item;
  }

  //save query
  savequery(data, parent) {
    this.querym.query = data;
    if (parent != 0)
      this.querym.parent = parent;
    this.querym.createdby = this.userid;
    this.querym.requestdetailid = this.requestdetailid;
    this.querym.requesttypeid = this.requesttypeid;
    if (this.redirectype == 'Query')
      this.querym.type = 'query';
    else
      this.querym.type = 'comment';
    this.querycommentservice.Post(this.querym).subscribe(res => {
      if (res.status == 200) {
        if (res.body != 0) {
          this.id = res.body;
        //  this.comments = [];
          this.getAll();
          if (this.redirectype == 'Query') {
            this.requeststatus.requestdetailid = this.requestdetailid;
            this.requeststatus.requesttypeid = this.requesttypeid;
            this.requeststatus.createdby = this.userid;
            this.requeststatus.statusid = 3;
            this.requestdashboardservice.Post(this.requeststatus).subscribe(
              (res) => {
                if (res.body != 0) {

                }
              }, error => {
                this.toastr.error("Error while Adding request status");
              });
          }
        }
      };
    },
      error => {
        this.toastr.error("Error while Adding query/comments");
        this.id = '';
      });
  }
  //edit query
  editquery(content, id) {
    this.querym.queryid = id;
    this.querym.query = content;
    this.querym.modifiedby = this.userid;
    this.querym.requestdetailid = this.requestdetailid;
    this.querym.requesttypeid = this.requesttypeid;
    this.querycommentservice.Put(this.querym).subscribe(res => {
      if (res.status == 200) {
        this.getAll();
      };
    },
      error => {
        this.toastr.error("Error while editing query/comments");
      });
  }

  //delete query
  deletequery(id) {
    this.querym.queryid = id;
    this.querym.modifiedby = this.userid;
    this.querym.requestdetailid = this.requestdetailid;
    this.querym.requesttypeid = this.requesttypeid;
    this.querycommentservice.Delete(this.querym).subscribe(res => {
      if (res.status == 200) {
     //   this.comments = [];
        this.getAll();
      };
    },
      error => {
        this.toastr.error("Error while Deleting query/comments");
      });
  }
}
